import { Map } from 'immutable';

import { WAIT_KEY } from './reducers';

export const getImplicitWait = state => state.getIn([WAIT_KEY, 'implicit'], Map());

export const getExplicitWait = state => state.getIn([WAIT_KEY, 'explicit'], Map());

export const getExplicitWaitMessage = state => getExplicitWait(state).get('message');

export const getExplicitWaitTransparent = state => getExplicitWait(state).get('transparent');

export const getExplicitWaitVisible = state => getExplicitWait(state).get('visible');

export const getImplicitWaitVisible = state => getImplicitWait(state).get('visible');

export const getWaitVisible = state =>
    getExplicitWaitVisible(state) || getImplicitWaitVisible(state);

export const getExplicitWaitStartTime = state => getExplicitWait(state).get('startTime');
